import React from 'react';
import { AIcon } from '../../atoms/AIcon/index';
import { ALabel } from '../../atoms/ALabel/index';
import type { MPhotoCaptionProps } from './MPhotoCaption.types';
import * as Styled from './MPhotoCaption.styles';

const COMPONENT_NAME = 'm-web-ui-kit-MPhotoCaption';
const TEST_ID = 'web-ui-kit-MPhotoCaption';

export const MPhotoCaption: React.FC<MPhotoCaptionProps> = ({ aIcon, aLabel, className, ...rest }) => {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className} {...rest}>
      {aIcon && <AIcon {...aIcon} />}
      {aLabel && <ALabel {...aLabel} />}
    </Styled.Wrapper>
  );
};

export { TEST_ID as M_PHOTO_CAPTION_TEST_ID };
